import { useMemo } from "react";
import { useTranslation } from "../localization";
/** Two literal favorite keys: dynamic i18n keys are not allowed. */
export default function useDiscoverChatbotProfileOverlayLabels() {
    const { t } = useTranslation();
    return useMemo(() => ({
        chatNow: t("common:chatNow"),
        favorite: t("common:favorite"),
        favorited: t("common:favorited"),
        share: t("common:share"),
        close: t("common:close"),
        retry: t("error:cta.tryAgain"),
        error: t("error:title.somethingWentWrong"),
        notFound: t("chat:page.alert.unavailableChatbot.description"),
        privateLorebook: t("chatbot:profile.privateLorebook"),
        greeting: t("chatbot:profile.greeting"),
        personality: t("chatbot:profile.personality"),
        scenario: t("chatbot:profile.scenario"),
        exampleDialogue: t("chatbot:profile.exampleDialogues"),
        showMore: t("chatbot:profile.showMore"),
        showLess: t("chatbot:profile.showLess"),
        messages: t("chatbot:profile.messages"),
        likes: t("chatbot:profile.likes"),
        tokens: t("chatbot:profile.tokens"),
        recommended: t("chatbotCard:badge.forYou"),
        more: t("chatbotCard:tooltip.moreActions"),
        blockCreator: t("chatbotCard:dropdown.blockCreator"),
        report: t("chatbotCard:dropdown.report"),
        lessLikeThis: t("chatbotCard:dropdown.lessLikeThis"),
    }), [t]);
}
